"use client";

import { cn } from "@/lib/utils";
import { useTheme } from "next-themes";
import { useEffect, useRef, useState } from "react";

interface PropsType {
  className?: string;
}

const TrustpilotWidget = ({ className }: PropsType) => {
  const ref = useRef<HTMLDivElement>(null);
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (
      mounted &&
      window.Trustpilot &&
      typeof window.Trustpilot.loadFromElement === "function"
    ) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, [mounted, resolvedTheme]);

  if (!mounted || !resolvedTheme) return null;

  const trustpilotTheme = resolvedTheme === "dark" ? "dark" : "light";

  return (
    <div
      ref={ref}
      className={cn("trustpilot-widget", className)}
      style={{ colorScheme: "light" }}
      data-locale="en-US"
      data-template-id="5419b732fbfb950b10de65e5"
      data-businessunit-id="64db6af868169ad313f5b67a"
      data-style-height="50px"
      data-style-width="100%"
      data-theme={trustpilotTheme}
    >
      <a
        href="https://www.trustpilot.com/review/esimcard.com"
        target="_blank"
        rel="noopener noreferrer"
      />
    </div>
  );
};

export default TrustpilotWidget;
